import {
    BoardHeader,
    ChartContainer,
    ChartLabel,
    ChartLabels,
    ChartTooltip,
    DashBoardBody,
    DashBoardCard,
    DashBoardHeader, selectStyle,
} from "../../assets/GlobalStyles";
import {ResponsiveLine} from '@nivo/line'
import React, {useEffect, useState} from "react";
import {useAtom, useAtomValue} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import {
  chartDataAtom,
  commonProperties,
  platformStatusType,
  userPlatformStatusType
} from "./entity/Chart";
import {
  adverCampaignColumn, adverCampaignDetailColumn,
  adverListColumn,
  adverStatusAtom,
  adverStatusDetailAtom,
  adverStatusDetailColumn, lockedRows, summaryReducer,
  userCampaignListColumn,
} from "./entity/Campaign";
import {targetingType, productType, searchConditionAtom} from "./entity/Common";
import {tokenResultAtom} from "../login/entity/Common";
import {
  retrieveAdvertiserCampaignStatus,
  retrieveAdvertiserStatus, retrieveUserAdvertiserCampaignStatus
} from "../../services/dash_board/ManageCampaignAxios";
import Table from "../../components/table";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";

/** 플래폼 현황 차트 **/
function CampaignBoard(props) {
  const {} = props;
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo)
  const [adverStatusData, setAdverStatusData] = useAtom(adverStatusAtom)
  const [adverStatusDetailData, setAdverStatusDetailData] = useAtom(adverStatusDetailAtom)
  const [searchCondition, setSearchCondition] = useAtom(searchConditionAtom)
  const [searchState, setSearchState] = useState(null)
  const [keyword, setKeyword] = useState('')
  const [gridRef, setGridRef] = useState(null);
  //useEffect(() => {
  //  if(tokenUserInfo.role !=='') {
  //    if(tokenUserInfo.role !== 'NORMAL') {
  //      //광고주 현황 조회
  //      retrieveAdvertiserStatus(searchCondition).then(response => {
  //        if(response !== null) {
  //          setAdverStatusData(response)
  //          setTotalInfo({
  //            totalCount: response.length
  //          })
  //        } else {
  //          setAdverStatusData([])
  //        }
  //      })
  //    } else {
  //      retrieveUserAdvertiserCampaignStatus(tokenUserInfo.id, searchCondition).then(response => {
//
  //        if(response !== null) {
  //          setAdverStatusData(response)
  //          setTotalInfo({
  //            totalCount: response?.length
  //          })
  //        } else {
  //          setAdverStatusData([])
  //        }
  //      })
  //    }
  //  }
  //  searchCondition.keyword !== '' ? setKeyword(searchCondition.keyword) : setKeyword('')
  //  setSearchState({
  //    ...searchCondition
  //  })
  //  // eslint-disable-next-line react-hooks/exhaustive-deps
  //}, [searchCondition, tokenUserInfo])
  const renderContactsGrid = () => {
    return (
        <ReactDataGrid
            handle={null}
            clearNodeCacheOnDataSourceChange={true}
            dataSource={adverStatusDetailData}
            defaultSortInfo={{name:"campaignName", dir: -1}}
            columns={adverCampaignDetailColumn}
            enableColumnAutosize={true}
            groups={false}
            emptyText={'캠페인 리스트가 없습니다.'}
            rowHeight={50}
            headerHeight={40}
            style={{minHeight: 40, marginLeft: '50px'}}
            showHoverRows={false}
            activeCell={null}
        />
    );
  }
  const rowExpandHeight = ({data}) => {
    if (data?.campaignCount !== 0) {
      if (data.campaignCount < 6) {
        return 112 + (data.campaignCount * 45);
      } else {
        return 442;
      }
    } else {
      return 300;
    }
  }
  return (
      <>
        <BoardHeader>{tokenUserInfo.role !== 'NORMAL' ? '광고주별 캠페인' : '캠페인'} 현황</BoardHeader>
        <DashBoardBody>
          {tokenUserInfo.role !== 'NORMAL' ?
              <ReactDataGrid
                  licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                  handle={null}
                  activeCell={null}
                  lockedRows={lockedRows}
                  summaryReducer={summaryReducer}
                  onReady={setGridRef}
                  style={{minHeight: 700}}
                  headerHeight={40}
                  rowExpandHeight={rowExpandHeight}
                  rowHeight={40}
                  renderDetailsGrid={renderContactsGrid}
                  enableColumnAutosize={true}
                  emptyText={'데이터가 없습니다.'}
                  idProperty={'userId'}
                  defaultSortInfo={{name:"username", dir: -1}}
                  dataSource={adverStatusData}
                  detailsGridCacheKey={'campaignId'}
                  columns={adverCampaignColumn}
                  onDataSourceCacheChange={() => {
                    gridRef?.current.collapseAllRows()
                  }}
                  //onRowExpand={({id})=>retrieveAdvertiserCampaignStatus(id, searchCondition).then(r=> setAdverStatusDetailData(r))}
                  onRowExpand={({data}) => {
                    retrieveAdvertiserCampaignStatus(data?.userId,
                        searchCondition).then(response => {

                      response !== null && setAdverStatusDetailData(
                          response?.map(item => {
                            return {
                              ...item,
                              userId: data?.userId,
                              adverInfo: `${data?.adverName}(${data?.username})`
                            }
                          })
                      )
                    })
                  }}
                  limit={30}
                  multiRowExpand={false}
                  showHoverRows={false}
              />
              : <Table columns={userCampaignListColumn}
                       totalCount={[totalInfo.totalCount, '캠페인']}
                       rowHeight={null}
                       defaultSortInfo={{name:"username", dir: -1}}
                       data={adverStatusData}/>
          }
        </DashBoardBody>
      </>
  );
}
export default CampaignBoard;